import { ProfilePageWithModal } from "./ProfilePage";
import SecurityPage from "./SecurityPage";

const MyProfile = {
  ProfilePageWithModal,
  SecurityPage,
};
export default MyProfile;
